module.exports = __webpack_public_path__ + "img/gun-squirt.c02fecc4.svg";